import { useState, useCallback } from 'react';
import API from 'api/api';

export default function useApproveTruck() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const approveTruck = useCallback(async (truckId, payload = {}) => {
    setLoading(true);
    setError(null);

    try {
      await API.put(`/trucks/${truckId}/approve`, payload);
      return true;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { approveTruck, loading, error };
}
